<template>
    <div class="panel"
         v-loading="loading">

        <div class="segments-container"
             v-for="(item, index) in translationSegments"
             :key="item.translationSegmentId">

            <SegmentItemPreview :modelValue="item"
                                :rowNumber="getRowNumber(index)" />
        </div>

        <div class="paging-box">
            <el-pagination layout="prev, pager, next"
                           :total="paging.rowCount"
                           :current-page="paging.currentPageNumber"
                           :default-page-size="paging.pageSize"
                           @current-change="goToPage" />
        </div>


    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { archivedDocumentService } from './archivedDocumentService'
    import { LoadSegmentsRequest } from '@/models/LoadSegmentsRequest';
    import SegmentItemPreview from './SegmentItemPreview.vue'

    export default defineComponent({
        name: 'TranslationSegmentsPanel',
        components: {
            SegmentItemPreview,
        },
        props: {
            scrollOnLoad: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                loading: false,
                translationSegments: [] as any[],
                paging: {
                    currentPageNumber: 1,
                    pageSize: 50,
                    rowCount: 0,
                    pageCount: 0,
                },
                archivedDocumentService: new archivedDocumentService(),
            };
        },
        mounted() {
            this.loadTranslationSegments(this.scrollOnLoad);
        },
        computed: {
            documentId(): number {
                return Number(this.$route.params.id);
            },
            pageRequest(): LoadSegmentsRequest {
                var request: LoadSegmentsRequest = {
                    DocumentId: this.documentId,
                    Paging: {
                        PageNumber: this.paging.currentPageNumber,
                        PageSize: this.paging.pageSize
                    },
                }
                return request;
            },
        },
        methods: {
            scrollToTop(): void {
                const element = this.$el as HTMLElement;
                if (element) {
                    window.scrollTo({
                        top: element.offsetTop,
                        behavior: 'auto'
                    });
                }
            },
            getRowNumber(index: number): number {
                const baseNumber = (this.paging.currentPageNumber - 1) * this.paging.pageSize
                const currentPageRowNumber = index + 1;
                return baseNumber + currentPageRowNumber;
            },

            async goToPage(pageNumebr: number): Promise<void> {
                this.paging.currentPageNumber = pageNumebr;
                await this.loadTranslationSegments(true);
            },

            async loadTranslationSegments(scroll: boolean = true): Promise<void> {
                try {
                    this.loading = true;
                    const translationResult = await this.archivedDocumentService.loadTranslationSegments(this.pageRequest);

                    this.translationSegments = translationResult.results;
                    this.paging.rowCount = translationResult.rowCount;
                    this.paging.pageCount = translationResult.pageCount;

                    if (scroll) {
                        this.$nextTick(() => {
                            // Scroll to the top of the component
                            this.scrollToTop();
                        });
                    }
                } catch (error) {
                    console.error('Failed to load translation segments:', error);
                } finally {
                    this.loading = false;
                }
            },
        },
    })
</script>

<style lang="scss" scoped>
    .panel {
        background-color: #ffffff;
        color: #303133;
        transition: 0.3s;

        & > div.segments-container:nth-child(2n+1) {
            background-color: var( --light-blue);
        }

        .paging-box {
            display: flex;
            justify-content: space-around;
            padding: 20px 0;
        }
    }

</style>